import { AxiosInstance } from 'axios';

export interface ExactTokenEvent {
    at: string;
    text: string;
}

export interface ExactTokenGap {
    from: string;
    to: string;
    unauthorized: number;
}

/** The Exact token of one environment over the last hours. Mirrors ExactTokenHistoryDto. */
export interface ExactTokenHistory {
    customer: string;
    environment: string;
    from: string;
    to: string;
    renewals: string[];
    failures: ExactTokenEvent[];
    expired: ExactTokenGap[];
    unauthorized: ExactTokenEvent[];
    error?: string | null;
}

export const getExactTokenHistory = async (axios: AxiosInstance, customer: string, environment: string, hours: number, signal?: AbortSignal): Promise<ExactTokenHistory> => {
    const response = await axios.get(`/Exact/${encodeURIComponent(customer)}/${encodeURIComponent(environment)}/token-history?hours=${hours}`, { signal });

    // The generated client's axios instance hands the body back as text.
    return (typeof response.data === 'string' ? JSON.parse(response.data) : response.data) as ExactTokenHistory;
};
